'use client';

import React, { useEffect } from 'react';
import { usePathname } from 'next/navigation';

const INTERCOM_APP_ID = process.env.NEXT_PUBLIC_INTERCOM_APP_ID || 'i9iq5u7x';
// https://app.asana.com/1/1202055782744194/project/1202066441740098/task/1214093840303623?focus=true
const BEYOND_PAGES = [
  'https://www.beyondboring.net/beyond',
  'https://www.beyondiqcapital.com/beyond',
  'https://www.beyondboring.net/beyond-imprint',
  'https://www.beyondiqcapital.com/beyond-imprint',
  'https://www.beyondboring.net/beyond-privacy',
  'https://www.beyondiqcapital.com/beyond-privacy',
  'https://www.beyondboring.net/terms-and-conditions',
  'https://www.beyondiqcapital.com/terms-and-conditions',
];

// pages where the chat launcher stays hidden
const HIDDEN_LAUNCHER_PATHS = [
  '/de/challenge',
  '/futures-offer',
  '/de/futures-angebot',
  '/offer',
  '/de/angebot',
  '/launch-event',
  '/de/launch-event',
  '/launch-thankyou',
  '/de/launch-danke',
  '/launch-replay',
  '/de/launch-replay',
  '/welcome-offer-02/de',
];

const isLauncherHidden = (pathname: string) =>
  HIDDEN_LAUNCHER_PATHS.some(
    (path) => pathname === path || pathname === `${path}/`,
  );

const IntercomClientComponent: React.FC = () => {
  const pathname = usePathname();

  useEffect(() => {
    const currentURL = window.location.href;

    // to not load the chatbot in the Sanity studio pages
    if (pathname.includes('/studio')) return;

    if (BEYOND_PAGES.some((page) => currentURL.startsWith(page))) {
      return;
    }

    const intercomSettings = {
      api_base: 'https://api-iam.intercom.io',
      app_id: INTERCOM_APP_ID,
      hide_default_launcher: isLauncherHidden(pathname),
    };

    window.intercomSettings = intercomSettings;

    if (window.Intercom) {
      window.Intercom('reattach_activator');
      window.Intercom('update', intercomSettings);
    } else {
      const intercomScript = document.createElement('script');
      intercomScript.type = 'text/javascript';
      intercomScript.async = true;
      intercomScript.src = `https://widget.intercom.io/widget/${INTERCOM_APP_ID}`;
      intercomScript.onload = () => window.Intercom('update', intercomSettings);
      document.body.appendChild(intercomScript);
    }
  }, [pathname]);
  return null;
};

export default IntercomClientComponent;
